import Header from "./components/Header/Header";
import Form from "./components/Form/Form";
import "./App.css";

function App() {
  return (
    <div className="app">
      <Header />
      <Form />
    </div>
  );
}

export default App;
